import ImagePreview from './ImagePreview'

export default ImagePreview


// WEBPACK FOOTER //
// app/javascript/components/fields/ImagePreview/index.js